import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap, TimelineLite, TweenLite} from "gsap";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborSoundManager} from "../../sound/PearlHarborSoundManager";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {CocpitBoard} from "./CocpitBoard";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class KamakaziWinPresentation extends PIXI.Container implements StageLayer {

    private _spine:PIXI.spine.Spine;
    private _baseWinNumber:PIXI.Text;
    private _black:PIXI.Graphics;

    constructor() {
        super();
        this.name = "KamakaziWinPresentation";
        this.init();
    }

    public hide(duration:number = 0.0001):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        if(!this.visible) {
            return tl;
        }

        tl.to(this, {duration : duration, alpha : 0});
        tl.add(() => {
            this.removeChildren();
            this.visible = false;
            this._spine.state.setEmptyAnimation(0, 0);
            this._baseWinNumber.text = "";
        });
        return tl;
    }

    public onResize():void {
        if(!this.visible) {
            return;
        }
    }

    public show():gsap.core.Timeline {
        PearlHarbor.keypadPlugin.hide();
        this.addChild(this._spine);
        this.addChild(this._baseWinNumber);
        this.alpha = 0;
        this.visible = true;
        const kamikaziMult:number = PearlHarbor.model.dogfight?.kamikaziMult;
        const tl:TimelineLite = new TimelineLite();
        tl.add(TweenLite.to(this, 0.2, {alpha : 1, delay : 1}));
        tl.add([
            () => {
                PearlHarborSoundManager.onFsKamikazeAnimationStart();
            },
            new SpineTween(this._spine, 0, "intro")
        ]);

        let winNumberName:string = "miss_";
        const winNumber:number = kamikaziMult;
        if(winNumber < 2) {
            winNumberName += (Math.ceil(Math.random() * 4)).toString();
        } else {
            winNumberName = "x" + winNumber.toString();
        }
        const delay:number = tl.duration();
        let baseNumberStartScale = 1,
            baseNumberEndScale = 1.3;
        tl.add(new SpineTween(this._spine, 0, winNumberName));
        tl.add(() => {
            PearlHarborSoundManager.onFsKamikazeHitOrMiss(kamikaziMult > 1);
            this.addChildAt(this._black, 0);
            if(PearlHarbor.model.dogfight.kamikaziMult > 1) {
                this._baseWinNumber.text = PearlHarbor.cocpitBoard.totalMulText;
                this._baseWinNumber.scale.set(1);
                this._baseWinNumber.updateTransform();
                if(this._baseWinNumber.width * 1.3 > 700) {
                    baseNumberEndScale = MathHelper.roundToDecimals(700 / this._baseWinNumber.width, 2);
                    baseNumberStartScale = MathHelper.roundToDecimals(baseNumberEndScale / 1.3, 2);
                }
                this._baseWinNumber.scale.set(baseNumberEndScale);
                this._baseWinNumber.alpha = 1;
            }
            gsap.to(this._baseWinNumber.scale, {duration : 0.2, x : baseNumberStartScale, y : baseNumberStartScale});
        }, delay + 8);
        tl.add(gsap.to(this._baseWinNumber.scale, {duration : 2.87 - 0.2, x : baseNumberEndScale, y : baseNumberEndScale}), delay + 8.2);
        tl.add(gsap.to(this._baseWinNumber, {duration : 0.67, alpha : 0}), delay + 10.43);
        tl.add(() => {
            gsap.to(this, {duration : 0.2, alpha : 0, delay : PearlHarbor.model.gameData.brokeBank ? 1.951 : 1});
        });
        return tl;
    }

    private init():void {
        this._black = new PIXI.Graphics();
        this._black.beginFill(0x000000, 1);
        this._black.drawRect(-840, -840, 1680, 1680);
        this._black.endFill();
        this._black.position.set(360, 360);

        this._spine = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset("kamakazi"))
        this._spine.position.set(360, 360);

        this._baseWinNumber = new PIXI.Text("", CocpitBoard.TOTAL_MULTIPLIER);
        this._baseWinNumber.anchor = new PIXI.Point(0.5, 0.5);
        this._baseWinNumber.position.set(360, 200);

        this.visible = false;
    }
}